import React from 'react';
import {observer} from "mobx-react";
import {GameInfo} from '../../../../services/games/game-info';
import {useServices} from '../../../../react-hooks/use-services.hook';
import {VideoTileOverlayComponent} from '../../../live-streaming-tile/video-common-components/video-tile-overlay/video-tile-overlay.component';
import {VideoSlideBox} from './boxes/video-slide.box';
import {VideoSlideFooterComponent} from './components/video-slide-footer/video-slide-footer.component';
import {VideoSlideContainer} from './boxes/video-slide-container.box';

interface VideoSlideComponentProps {
    gameInfo: GameInfo;
}
export const VideoSlideComponent: React.FC<VideoSlideComponentProps> = observer((props) => {
    const services = useServices();

    const _renderFooter = () => {
        return (
            <VideoSlideFooterComponent
                gameInfo={props.gameInfo}
                type={"bets"}
            />
        );
    }

    const _renderPlayer = () => {
        const staticVideoPlaying = services.staticVideoPlaying;
        return (
            <div style={{height: '100%'}}>
                <VideoSlideContainer
                    gameInfo={props.gameInfo}
                    muted={staticVideoPlaying.isVideoMuted}
                    isInCenterStage={true}
                    inViewport={true}
                    display={true}
                    videoPlayingService={staticVideoPlaying}
                    onWatchTimeLimitReached={() => {}} //TODO we will have a task for videoPlayer
                    onLoading={() => {}} //TODO we will have a task for videoPlayer
                    onError={() => {}} //TODO we will have a task for videoPlayer
                />
                <VideoTileOverlayComponent
                    videoPlayingService={staticVideoPlaying}
                    videoPlaying={true}
                />
            </div>
        );

    }

    return (
        <VideoSlideBox>
            {_renderPlayer()}
            {_renderFooter()}
        </VideoSlideBox>
    )
})
